var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.25V2.08342C3.75 1.6167 3.75 1.38318 3.84083 1.20492C3.92072 1.04811 4.04811 0.920721 4.20492 0.840829C4.38317 0.75 4.61671 0.75 5.08342 0.75H7.41675C7.88346 0.75 8.11671 0.75 8.29496 0.840829C8.45175 0.920721 8.57938 1.04811 8.65925 1.20492C8.75008 1.38318 8.75008 1.61653 8.75008 2.08324V4.41658C8.75008 4.88329 8.75008 5.11667 8.65925 5.29492C8.57938 5.45171 8.45163 5.57937 8.29483 5.65925C8.11675 5.75 7.88375 5.75 7.41796 5.75H6.25M3.75 3.25H2.58342C2.1167 3.25 1.88318 3.25 1.70492 3.34083C1.54811 3.42072 1.42072 3.54811 1.34083 3.70492C1.25 3.88317 1.25 4.11671 1.25 4.58342V6.91675C1.25 7.38346 1.25 7.61671 1.34083 7.79496C1.42072 7.95175 1.54811 8.07937 1.70492 8.15925C1.883 8.25 2.11625 8.25 2.58205 8.25H4.91817C5.38396 8.25 5.61687 8.25 5.79496 8.15925C5.95175 8.07937 6.07937 7.95162 6.15925 7.79483C6.25 7.61675 6.25 7.38375 6.25 6.91796V5.75M3.75 3.25H4.91675C5.38346 3.25 5.61671 3.25 5.79496 3.34083C5.95175 3.42072 6.07937 3.54811 6.15925 3.70492C6.25 3.883 6.25 4.11625 6.25 4.58204V5.75",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.249ede86bb847f7133917b003f6b66b2.svg";
export { ForwardRef as ReactComponent };